import Api from "./Api";

const abortKey = "FiBuOffenePostenApi";
const endpoint = "/fibu/offene_posten";
export default {
    abort() {
        Api.abort(abortKey);
    },
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint, usedParams, true, false, abortKey);
    },
    getSums(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + '/sums', usedParams, true, false, abortKey);
    },
    getSingle(id, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/" + id, usedParams);
    },
    getSingleForBuchung(id) {
        return Api.fetchData(endpoint + "/" + id + "/buchung");
    },
    getRelated(id) {
        return Api.fetchData(endpoint + `/${id}/` + 'related');
    },
    getGuthaben(id) {
        return Api.fetchData(
            endpoint + `/${id}/` + 'guthaben'
        )
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    postBuchungForOP(id, data) {
        return Api.postData(endpoint + '/' + id + '/verbuchen', data);
    },
    postGuthabenToOP(id, data) {
        return Api.postData(endpoint + `/${id}/` + 'guthaben-verbuchen', data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
